import { c as _c } from "react/compiler-runtime";
import InlineRatingContent from './InlineRatingContent';
import NoRating from './NoRating';
const LoadedInlineRating = (t0) => {
    const $ = _c(15);
    let average;
    let count;
    let onClick;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ onClick, average, count, className: t1, ...props } = t0);
        $[0] = t0;
        $[1] = average;
        $[2] = count;
        $[3] = onClick;
        $[4] = props;
        $[5] = t1;
    }
    else {
        average = $[1];
        count = $[2];
        onClick = $[3];
        props = $[4];
        t1 = $[5];
    }
    const className = t1 === undefined ? "" : t1;
    const computedClassName = `flex flex-row items-center ${className}`;
    const computedAverage = average || 0;
    const computedCount = count || 0;
    const noRating = computedCount === 0;
    let t2;
    if ($[6] !== computedAverage || $[7] !== computedCount || $[8] !== noRating || $[9] !== props) {
        t2 = noRating ?
            <NoRating /> :
            <InlineRatingContent average={computedAverage} count={computedCount} {...props}/>;
        $[6] = computedAverage;
        $[7] = computedCount;
        $[8] = noRating;
        $[9] = props;
        $[10] = t2;
    }
    else {
        t2 = $[10];
    }
    const content = t2;
    let t3;
    if ($[11] !== computedClassName || $[12] !== content || $[13] !== onClick) {
        t3 = onClick ?
            <button onClick={onClick} className={computedClassName}>
      {content}
    </button> :
            <div className={computedClassName}>{content}</div>;
        $[11] = computedClassName;
        $[12] = content;
        $[13] = onClick;
        $[14] = t3;
    }
    else {
        t3 = $[14];
    }
    return t3;
};
const InlineRatingSkeleton = (t0) => {
    const $ = _c(2);
    const { className: t1 } = t0;
    const className = t1 === undefined ? "" : t1;
    const computedClassName = `inline-rating skeleton w-2/5 h-4 flex-grow-0 ${className}`;
    let t2;
    if ($[0] !== computedClassName) {
        t2 = <div className={computedClassName}> </div>;
        $[0] = computedClassName;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    return t2;
};
const InlineRating = (t0) => {
    const $ = _c(6);
    let loading;
    let props;
    if ($[0] !== t0) {
        ({ loading, ...props } = t0);
        $[0] = t0;
        $[1] = loading;
        $[2] = props;
    }
    else {
        loading = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== loading || $[4] !== props) {
        t1 = loading ?
            <InlineRatingSkeleton className={props.className}/> :
            <LoadedInlineRating {...props}/>;
        $[3] = loading;
        $[4] = props;
        $[5] = t1;
    }
    else {
        t1 = $[5];
    }
    return t1;
};
export default InlineRating;
